<script setup lang="ts">
import { computed } from 'vue';

import { UiButton, UiDialogShell } from '@peanuds/ui';
import sessionExpiredDialogIllustration from '../assets/session-expired-dialog-illustration.png';

interface Props {
  visible: boolean;
  isSignInRedirectLoading?: boolean;
}

const { visible, isSignInRedirectLoading = false } = defineProps<Props>();

const emit = defineEmits<{
  continue: [];
}>();

const SESSION_EXPIRED_DIALOG_TITLE = 'Session Expired';
const SESSION_EXPIRED_DIALOG_MESSAGE =
  'For security reasons, your session has expired due to inactivity. Please sign in again to access your account.';
const SESSION_EXPIRED_DIALOG_CONTINUE = 'Continue to sign in';

const isContinueDisabled = computed(() => {
  return isSignInRedirectLoading;
});

const handleContinue = () => {
  if (isSignInRedirectLoading) {
    return;
  }

  emit('continue');
};
</script>

<template>
  <UiDialogShell
    :visible="visible"
    max-width="calc(100vw - 2rem)"
    :dismissable-mask="false"
    :close-on-escape="false"
    :close-disabled="isContinueDisabled"
    :close-label="SESSION_EXPIRED_DIALOG_CONTINUE"
    :title="SESSION_EXPIRED_DIALOG_TITLE"
    :description="SESSION_EXPIRED_DIALOG_MESSAGE"
    :illustration="sessionExpiredDialogIllustration"
    :pt="{
      mask: {
        class: 'session-expired-dialog__mask',
      },
    }"
    @close="handleContinue"
  >
    <template #actions>
      <UiButton
        :label="SESSION_EXPIRED_DIALOG_CONTINUE"
        :loading="isSignInRedirectLoading"
        :disabled="isContinueDisabled"
        @click="handleContinue"
      />
    </template>
  </UiDialogShell>
</template>

<style scoped lang="scss">
:global(.session-expired-dialog__mask) {
  padding: $space-md;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(4px);
}
</style>
